import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";

const EditPage = ({ items, handleEdit }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [editItem, setEditItem] = useState(null);

  useEffect(() => {
    console.log("Items in EditPage:", JSON.stringify(items, null, 2)); // Debugging
    if (items.length > 0) {
      const foundItem = items.find((item) => String(item.itemid) === id); // Ensure ID comparison is string-based
      if (foundItem) {
        setEditItem({ ...foundItem });
      } else {
        console.error("Item not found with ID:", id);
      }
    }
  }, [id, items]);

  const handleChange = (colIndex, newValue) => {
    setEditItem((prev) => {
      const updated = { ...prev };
      updated.column[colIndex].rawdata.value = newValue;
      return updated;
    });
  };

  const handleSave = () => {
    handleEdit(editItem);
    navigate("/");
  };

  if (!editItem) return <p>Loading...</p>;

  return (
    <div style={{ padding: "20px" }}>
      <h2>Edit Item {editItem.itemid}</h2>
      {editItem.column.slice(0, 5).map((col, colIndex) => (
        <div key={colIndex} style={{ marginBottom: "10px" }}>
          <label>Column {colIndex + 1}:</label>
          <input
            type="text"
            value={col.rawdata?.value || ""}
            onChange={(e) => handleChange(colIndex, e.target.value)}
            style={{ marginLeft: "10px", padding: "5px" }}
          />
        </div>
      ))}
      <button
        onClick={handleSave}
        style={{
          backgroundColor: "green",
          color: "white",
          padding: "10px 15px",
          marginRight: "10px",
        }}
      >
        Save
      </button>
      <button
        onClick={() => navigate("/")}
        style={{
          backgroundColor: "gray",
          color: "white",
          padding: "10px 15px",
        }}
      >
        Cancel
      </button>
    </div>
  );
};

export default EditPage;
